import styled from "styled-components";

export const JobCategory = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden !important;
  word-break: break-word;
`;
